<template lang="pug">
  .head
    .head__content
      .head__logo
      .head__desc(v-html="frontendSettings.head_description")
      template(v-if="promoIsActive")
        a.head__rules(:href="frontendSettings.rules_link" target="_blank" v-html="$t('promo.rules')")
        .head__prize
          .container
            .head__prize__left
              .head__prize__title(v-html="frontendSettings.banner_title")
              .head__prize__desc(v-html="frontendSettings.banner_description")
            img.head__prize__right(:src="frontendSettings.banner_image")
      .head__wait(v-else v-html="$t('promo.wait')")
</template>

<script>
export default {
  name: "PromoHead",
  props: {
    promoIsActive: {
      type: Boolean,
      default: false,
    },
    frontendSettings: {
      type: Object,
      default: null,
    },
  },
}
</script>